// Modules
import React from 'react';
import {connect} from 'react-redux';
import {BrowserRouter as Router, Route, Link} from 'react-router-dom';
import {SERVER_URL} from '../.config';
import {appurl} from './landing';
import store from '../store';
import {logout} from '../actions/user';
import {resetGameMngtState, refreshRoomsListSocket, refreshRoomsListLocal, leaveGameSocket} from '../actions/gameManagement';
import {resetMatchState, leaveGameLocal} from '../actions/matchManagement';
import {resetHistoryState} from '../actions/history';
import io from 'socket.io-client'
// Comps
import MainLanding from './mainLanding';
import MenuMain from './menu-main';
import Account from './account';
import GameNew from './gameNew';
import GameJoin from './gameJoin';
import Game from './game';
import History from './history';
let socket;

export class Main extends React.Component{

    constructor(props){
        super(props);
        socket = io(SERVER_URL);
    }

    componentDidMount(){
        store.dispatch(refreshRoomsListSocket(socket));
    }

    componentWillUnmount(){
        socket.disconnect();
        console.log('Disconnecting socket as Component will un-mount.');
    }

    logout(e){
        e.preventDefault();

        let gameroomPayload={
            socket,
            gameroom: store.getState().match.gameroom
        };
        store.dispatch(leaveGameSocket(gameroomPayload));
        store.dispatch(leaveGameLocal());

        store.dispatch(logout());
        store.dispatch(resetGameMngtState());
        store.dispatch(resetMatchState());
        store.dispatch(resetHistoryState());

        window.location.replace(appurl);
    }

    render(){
        socket.on('room-refresh-client', function(payload){
            console.log('Someone created a room or closed a room');
            console.log(payload);

            store.dispatch(refreshRoomsListLocal(payload));
        });

        if(!this.props.gameRunning){
            return(
                <Router>
                    <div id="main-landing">
                        <MenuMain/>
                        <div>
                            <Route exact path="/main" component={MainLanding}/>
                            <Route exact path="/main/account" component={Account}/>
                            <Route exact path="/main/game-new" render={(props)=>(<GameNew {...props} socket={socket}/>)}/>
                            <Route exact path="/main/game-join" render={(props)=>(<GameJoin {...props} socket={socket}/>)}/>
                            <Route exact path="/main/history" component={History}/>
                        </div>
                        <div>
                            <Link to="/">
                                <img src="./imgs/logout.svg" alt="Logout" className="mainMenuBtn" style={{"marginBottom": "1rem"}} onClick={e=>this.logout(e)}/>
                            </Link>
                        </div>
                    </div>
                </Router>
            );
        }

        else{
            return(
                <Router>
                    <div id="main-landing">
                        <MenuMain/>
                        <div>
                            <Route exact path="/main/account" component={Account}/>
                            <Route exact path="/main/game" render={(props)=>(<Game {...props} socket={socket}/>)}/>
                            <Route exact path="/main/history" component={History}/>
                        </div>
                        <div>
                            <Link to="/">
                                <img src="./imgs/logout.svg" alt="Logout" className="mainMenuBtn" style={{"marginBottom": "1rem"}} onClick={e=>this.logout(e)}/>
                            </Link>
                        </div>
                    </div>
                </Router>
            );
        }
    }
}

const mapStateToProps = state => ({
    gameRunning: state.gameMngt.gameRunning
});

export default connect(mapStateToProps)(Main);



// WEBPACK FOOTER //
// ./src/comps/main.js